import {isEmpty} from 'lodash';

import {UserSettings} from 'types';

const canSeeFilePipeline = (settings: UserSettings) => settings?.afterSession?.externalFiles?.filePipelineEnabled;

const getClientConnectionMessageAvailability = (settings: UserSettings) => {
    const {notification} = settings.clientConnect;
    return {
        smsEnabled: notification.sms?.enabled && !isEmpty(notification.sms?.messages),
        emailEnabled: notification.email?.enabled && !isEmpty(notification.email?.messages),
        whatsappEnabled:
            settings.featuresAvailability.whatsapp && notification.whatsapp?.enabled && !isEmpty(notification.whatsapp?.messages),
    };
};

export const settingsUtils = {
    canSeeFilePipeline,
    getClientConnectionMessageAvailability
};